// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
//import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyChnNdh1x7LVWm-JYkqJfrRevfhTNWHzJA",
  authDomain: "appdizquetem.firebaseapp.com",
  projectId: "appdizquetem",
  storageBucket: "appdizquetem.firebasestorage.app",
  messagingSenderId: "865903254087",
  appId: "1:865903254087:web:e59c3421e1ae12e2e76f62",
  measurementId: "G-4JEXGB0YRW"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
//const analytics = getAnalytics(app);
export const auth = getAuth(app);
export { app };